import { defineStore } from "pinia";
import { ref, type Ref } from "vue";
import { producers as list, initial } from "@/config/producers";
import { WhitelabelProducer } from "@/types/Producer";

export interface ProducersState {
  producers: WhitelabelProducer[];
  selected: WhitelabelProducer;
  default: WhitelabelProducer;
}

function defaultSelectedProducer(): WhitelabelProducer {
  let domain = window.location.hostname;

  if (domain.includes(".local")) {
    domain = domain.replace(".local", ".com.br");
  }

  let found = list.filter(p => p.active).find(p => p.domain === domain);

  found ??= list.find(p => p.id.includes("0"));
  found ??= list[0];

  return found;
}

export const useProducersStore = defineStore("producers", () => {
  // State
  const producers: Ref<WhitelabelProducer[]> = ref([ ...list ]);
  const selected: Ref<WhitelabelProducer> = ref(defaultSelectedProducer());
  const defaultProducer: Ref<WhitelabelProducer> = ref({ ...initial });

  // Actions
  function set(producer: WhitelabelProducer): void {
    selected.value = producer;
  }

  function reset(): void {
    producers.value = [ ...list ];
  }

  function setByDomain(domain: string): void {
    let found = producers.value.filter(p => p.active).find(p => p.domain === domain);

    found ??= producers.value.find(p => p.id.includes("0"));

    if (found) {
      set(found);
    }
  }

  return {
    producers,
    selected,
    default: defaultProducer,
    set,
    reset,
    setByDomain,
  };
});
